"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CreativeLayer = _interopRequireDefault(require("../../models/creative/CreativeLayer"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _ContentFrameData = _interopRequireDefault(require("./ContentFrameData"));

var ContentStore = /*#__PURE__*/function () {
  /** @type {Map} */
  function ContentStore() {
    (0, _classCallCheck2["default"])(this, ContentStore);
    (0, _defineProperty2["default"])(this, "_layers", null);
    this._layers = new Map();
  }
  /**
   * Get the ContentFrameData object for a given creativeLayer at the desired content-relative frame index
   * @param {CreativeLayer} creativeLayer
   * @param {number} contentFrameIndex
   * @returns {ContentFrameData}
   */


  (0, _createClass2["default"])(ContentStore, [{
    key: "getContentFrameData",
    value: function getContentFrameData(creativeLayer) {
      var contentFrameIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // Get the layer date from layers based on the key, if it isn't in the set return null
      if ((0, _isNil["default"])(creativeLayer)) return null; // TODO contentId might not be the best key here, but for now lets use it.

      if (!this._layers.has(creativeLayer.contentStoreId)) return null; // Get the layerFrames object

      var layerFrames = this._layers.get(creativeLayer.contentStoreId); // If it is null or empty, return null


      if ((0, _isNil["default"])(layerFrames) || layerFrames.size === 0) return null; // If the desired index doesn't exist, return null;

      if (!layerFrames.has(contentFrameIndex)) return null;
      return layerFrames.get(contentFrameIndex);
    }
    /**
     * Set the ContentFrameData object for a given creativeLayer at the desired content-relative frame index
     * @param {CreativeLayer} creativeLayer
     * @param {ContentFrameData} contentFrameData
     * @param {number} contentFrameIndex
     */

  }, {
    key: "setContentFrameData",
    value: function setContentFrameData(creativeLayer, contentFrameData) {
      var contentFrameIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (!_CreativeLayer["default"].isCreativeLayer(creativeLayer)) {
        throw new Error('creativeLayer is not of type CreativeLayer');
      }

      if (!_ContentFrameData["default"].isContentFrameData(contentFrameData)) {
        throw new Error('contentFrameData is not of type ContentFrameData');
      } // If we haven't seen this id before, make a new map.


      if (!this._layers.has(creativeLayer.contentStoreId)) {
        var newLayerFrames = new Map();

        this._layers.set(creativeLayer.contentStoreId, newLayerFrames);
      } // Get the layerFrame map from the layers map


      var layerFrames = this._layers.get(creativeLayer.contentStoreId);

      layerFrames.set(contentFrameIndex, contentFrameData);
    }
  }, {
    key: "clear",
    value: function clear(creativeLayer) {
      if (!this._layers.has(creativeLayer.contentStoreId)) return;

      var layerFrames = this._layers.get(creativeLayer.contentStoreId);

      layerFrames.clear();
    }
  }, {
    key: "clearAll",
    value: function clearAll() {
      this._layers.forEach(function (layerFrames) {
        return layerFrames.clear();
      });

      this._layers.clear();
    }
  }], [{
    key: "isContentStore",
    value: function isContentStore(inObject) {
      return inObject instanceof ContentStore;
    }
  }]);
  return ContentStore;
}();

exports["default"] = ContentStore;